"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonIcon = _interopRequireDefault(require("../../../atoms/buttons/buttonIcon/ButtonIcon"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

var _NotificationIcon = _interopRequireDefault(require("../../../protons/icons/NotificationIcon"));

var _BoxPosition = _interopRequireDefault(require("../../../layouts/box/boxPosition/BoxPosition"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  var _input, _searchBtn;

  return {
    input: (_input = {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRadius: 6,
      height: theme.spacing(6.5),
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2)
    }, _defineProperty(_input, theme.breakpoints.down("xs"), {
      height: theme.spacing(6)
    }), _defineProperty(_input, "& .MuiOutlinedInput-input", _defineProperty({
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      fontSize: theme.typography.h5.fontSize
    }, theme.breakpoints.down("xs"), {
      fontSize: theme.typography.body2.fontSize
    })), _input),
    searchBtn: (_searchBtn = {
      width: theme.spacing(6.5),
      height: theme.spacing(6.5),
      backgroundColor: theme.palette.primary.main,
      borderRadius: 6,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      flexGrow: 0,
      flexShrink: 0
    }, _defineProperty(_searchBtn, theme.breakpoints.down("xs"), {
      height: theme.spacing(6),
      width: theme.spacing(6)
    }), _defineProperty(_searchBtn, "&.Mui-disabled", {
      backgroundColor: theme.palette.grey[300]
    }), _searchBtn)
  };
});
/**
 *
 * ** Search allows users to navigate and find a particular information. Search field provides a hint text to inform users that it is a search field or which type of contents they can search for.  **
 *
 * The search button is inactive until a search term is entered in the field. Once a term in entered, a ‘close’ button is displayed, which on click, erase the search term so users can start a new search.
 *
 */

var Search = function Search(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      placeholder = _ref.placeholder,
      error = _ref.error,
      helperText = _ref.helperText,
      errorText = _ref.errorText,
      inputRef = _ref.inputRef,
      InputProps = _ref.InputProps,
      onFocus = _ref.onFocus,
      inputId = _ref.inputId,
      buttonId = _ref.buttonId,
      formHelperTextProps = _ref.formHelperTextProps;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex"
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    "data-testid": inputId,
    fullWidth: true,
    placeholder: placeholder,
    value: value,
    color: "primary",
    variant: "outlined",
    onChange: function onChange(event) {
      return _onChange(event.currentTarget.value);
    },
    error: error,
    helperText: error ? errorText : helperText,
    inputRef: inputRef,
    onFocus: onFocus,
    FormHelperTextProps: _objectSpread({
      style: {
        fontFamily: "Vodafone"
      }
    }, formHelperTextProps),
    InputProps: _objectSpread({
      className: styles.input,
      endAdornment: /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
        position: "relative"
      }, /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
        position: "absolute",
        right: "zero",
        top: "nSmall"
      }, /*#__PURE__*/_react.default.createElement(_core.Fade, {
        in: error
      }, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_NotificationIcon.default, {
        color: "red",
        icon: "ic_warning"
      })))), /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
        position: "absolute",
        right: "nSmall",
        top: "nXl"
      }, /*#__PURE__*/_react.default.createElement(_core.Fade, {
        in: value !== "" && !error
      }, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
        rounded: true,
        action: function action() {
          return _onChange("");
        },
        icon: "ic_close",
        variant: "tertiary",
        size: "large"
      })))))
    }, InputProps)
  }), /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    disabled: value === "",
    onClick: function onClick() {
      return onSubmit();
    },
    className: styles.searchBtn,
    disableRipple: true,
    "data-testid": buttonId
  }, /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
    icon: "ic_search",
    color: "white",
    size: "large"
  })));
};

Search.propTypes = {
  /** The search value of the field */
  value: _propTypes.default.string,

  /** The placeholder value of the field */
  placeholder: _propTypes.default.string,

  /** The action to call on change event (returns new value) */
  onChange: _propTypes.default.func,

  /** The action to call on submit */
  onSubmit: _propTypes.default.func,

  /** The action to call on focus */
  onFocus: _propTypes.default.func,

  /** The error state of the field */
  error: _propTypes.default.bool,

  /** The Helper text value of the field */
  helperText: _propTypes.default.string,

  /** The Error text of the field. (Replaces helperText in case of error) */
  errorText: _propTypes.default.string,

  /** Props applied to the Input element */
  InputProps: _propTypes.default.object,

  /** Pass a ref to the input element */
  inputRef: _propTypes.default.any,

  /** Props applied to the helper text element */
  formHelperTextProps: _propTypes.default.object
};
Search.defaultProps = {
  value: null,
  placeholder: null,
  onChange: null,
  onSubmit: null,
  onFocus: null,
  error: false,
  helperText: null,
  errorText: null,
  InputProps: null,
  inputRef: null,
  formHelperTextProps: null
};
var _default = Search;
exports.default = _default;